/**
 * Bandeau « beta » — pastille fixe dans un coin de l'écran. Au clic, ouvre
 * le questionnaire de feedback. Signale l'état beta du jeu et offre un
 * point d'entrée permanent pour donner son avis (pas seulement en fin).
 */

import { useGame } from "../store/useGame";

export function BetaBadge() {
  const openFeedback = useGame((s) => s.openFeedback);
  return (
    <button
      type="button"
      className="beta-badge"
      onClick={openFeedback}
      title="Version beta — donnez votre avis"
    >
      <span className="beta-badge-dot" aria-hidden="true" />
      BETA · votre avis
    </button>
  );
}
